import React, { useState } from 'react';
import '../styles/Research.css';
import { Link } from 'react-router-dom';
import { Copy, Check, X } from 'lucide-react';




const Research = () => {
  const [filter, setFilter] = useState('');
  const [expandedBib, setExpandedBib] = useState(null);
  const [copiedBib, setCopiedBib] = useState(null);

  // Sample publications data
  const publications = [
    {
      id: 1,
      title: "Experimental and numerical investigation on reliability of encapsulated sine wave interconnect for stretchable substrates",
      authors: "Deepesh Patidar, Arulsham Bhasin, Dr Vijay Pal",
      journal: "Microelectronics Reliability",
      date: "April 2024",
      year: "2024",
      category: "Journal Artical",
      route: '/researches/sinewave-interconnect',
      image: require('../assets/research/sinewaveinterconnect.png'),
      stats: {
        abs: false,
        doi: true,
        bib: true,
        citations: 1,
        doilink: "https://doi.org/10.1016/j.microrel.2024.115355"
      },
      bibData: `@article{Patidar2024,
  author = {Deepesh Patidar, Arulsham Bhasin, Vijay Kumar Pal},
  title = {Experimental and numerical investigation on reliability of encapsulated sine wave interconnect for stretchable substrates},
  journal = {Microelectronics Reliability},
  volume = {155},
  pages = {115355},
  year = {2024},
  publisher = {Elsevier},
  doi = {10.1016/j.microrel.2024.115355},
  url = {https://doi.org/10.1016/j.microrel.2024.115355}
}`
    },

   /* 
    {
      id: 2,
      title: "Denoising of magnetic resonance images of brain tumor using BT-Autonet",
      authors: "Mamta Juneja, Ashwani Rathee, Rishabh Verma, Raag Bhutani, Shashank Baghel, Sumindar Kaur Saini, Prashant Jindal",
      journal: "Biomedical Signal Processing and Control",
      date: "Jan 2024",
      year: "2024",
      category: "SS",
      route: '/researches/research-one',
      image: "/assets/placeholder/120/120",
      stats: {
        abs: false,
        doi: true,
        bib: true,
        citations: 5,
        doilink: "#"
      },
      bibData: `@article{juneja2024denoising,
  title={Denoising of magnetic resonance images of brain tumor using BT-Autonet},
  author={Juneja, Mamta and Rathee, Ashwani and Verma, Rishabh and Bhutani, Raag and Baghel, Shashank and Saini, Sumindar Kaur and Jindal, Prashant},
  journal={Biomedical Signal Processing and Control},
  volume={87},
  pages={105432},
  year={2024},
  publisher={Elsevier}
}`
    }, 
    
    */,
  
   /* Add here */

  
  ];

  const filteredPublications = publications.filter(pub =>
    pub.title.toLowerCase().includes(filter.toLowerCase()) ||
    pub.authors.toLowerCase().includes(filter.toLowerCase()) ||
    pub.journal.toLowerCase().includes(filter.toLowerCase())
  );

  const groupedByYear = filteredPublications.reduce((acc, pub) => {
    if (!acc[pub.year]) {
      acc[pub.year] = [];
    }
    acc[pub.year].push(pub);
    return acc;
  }, {});

  const handleDOI = (e, link) => {
    e.preventDefault();
    window.open(link);
  };

  const handleBib = (e, pubId) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandedBib(expandedBib === pubId ? null : pubId);
  };

  const handleCollapse = (e, pubId) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandedBib(null);
  };

  const copyToClipboard = async (text, pubId) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedBib(pubId);
      setTimeout(() => setCopiedBib(null), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="research-container">
      <div className="research-content">
        {/* Header */}
        <div className="research-header">
          <h1 className="research-title">Research</h1>
          <p className="research-subtitle">
             Note: I am making some changes to the website and you might have to refesh some pages once or twice

          </p>
        </div>

        {/* Filter Input and Bar*/}
        {/* <div className="filter-container">
          <input
            type="text"
            placeholder="Type to filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="filter-input"
          />
        </div> */}

        {/* Publications by Year */}
        {Object.keys(groupedByYear)
          .map(category => (
            <div key={category} className="year-section">
              {/* Year Header */}
              <div className="year-header">
                <h2 className="year-title">{category}</h2>
                <br />
                <hr className='divider' />
              </div>

              {/* Publications */}
              <div className="publications-list">
                {groupedByYear[category].map(pub => (
                  <div key={pub.id} className="publication-wrapper">
                    <Link className="no-underline" to={pub.route}>
                      <div className={`publication-card ${expandedBib === pub.id ? 'expanded' : ''}`}>
                        {/* Publication Image */}
                        <div className="simple-project-image">
                          <img className="simple-image-placeholder" src={pub.image} />
                        </div>

                        {/* Publication Details */}
                        <div className="publication-details">
                          <h3 className="publication-title">
                            {pub.title}
                          </h3>
                          <p className="publication-authors">
                            {pub.authors}
                          </p>
                          <p className="publication-journal">
                            {pub.journal}, {pub.date}
                          </p>

                          {/* Action Buttons */}
                          <div className="action-buttons">
                            {pub.stats.abs && (
                              <button className="action-btn">ABS</button>
                            )}
                            {pub.stats.doi && (
                              <button onClick={(e) => handleDOI(e, pub.stats.doilink)} className="action-btn">DOI</button>
                            )}
                            {pub.stats.bib && (
                              <button
                                onClick={(e) => handleBib(e, pub.id)}
                                className={`action-btn ${expandedBib === pub.id ? 'active' : ''}`}
                              >
                                BIB
                              </button>
                            )}
                          </div>

                          {/* Citations */}
                          <div className="citations-container">
                            <span className="citations-badge">
                              Citations: {pub.stats.citations}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>

                    {/* BIB Code Viewer */}
                    {expandedBib === pub.id && (
                      <div className="bib-viewer">
                        {/* Code Header */}
                        <div className="bib-header">
                          <span className="bib-title">BibTeX Citation</span>
                          <div className="bib-header-actions">
                            <button
                              onClick={() => copyToClipboard(pub.bibData, pub.id)}
                              className={`copy-btn ${copiedBib === pub.id ? 'copied' : ''}`}
                            >
                              {copiedBib === pub.id ? (
                                <>
                                  <Check size={12} />
                                  Copied!
                                </>
                              ) : (
                                <>
                                  <Copy size={12} />
                                  Copy
                                </>
                              )}
                            </button>
                            <button
                              onClick={(e) => handleCollapse(e, pub.id)}
                              className="collapse-btn"
                              title="Collapse"
                            >
                              <X size={14} color='white' />
                            </button>
                          </div>
                        </div>

                        {/* Code Content */}
                        <div className="bib-content">
                          <pre className="bib-code">
                            {pub.bibData}
                          </pre>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}

        {filteredPublications.length === 0 && (
          <div className="no-results">
            <p className="no-results-text">No publications found matching your filter.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Research;